import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import { useAuthStore } from '../stores/authStore';

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const res = await authApi.login(values);
      const { access, refresh, user } = res.data;
      setAuth(user as any, access, refresh);
      // 获取权限配置（非 student 角色需要）
      if (user.role !== 'student') {
        try {
          const meRes: any = await authApi.getMe();
          const perms = meRes.data?.permissions;
          if (perms) {
            useAuthStore.getState().updateUser({ permissions: perms } as any);
          }
        } catch {}
      }
      message.success(`欢迎回来，${user.real_name}！`);
      navigate('/dashboard', { replace: true });
    } catch (err: any) {
      message.error(err?.message || '登录失败，请检查用户名和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #16a34a 0%, #0d6e34 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card
        style={{ width: 400, borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}
        styles={{ body: { padding: '40px 40px 24px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              width: 64, height: 64, background: '#16a34a',
              borderRadius: '50%', display: 'inline-flex',
              alignItems: 'center', justifyContent: 'center',
              fontSize: 28, marginBottom: 16,
            }}
          >
            🔬
          </div>
          <Title level={3} style={{ margin: 0 }}>少科院管理系统</Title>
          <Text type="secondary">北京师范大学亚太实验学校</Text>
        </div>

        <Form name="login" onFinish={onFinish} size="large" autoComplete="off">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 8 }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登 录
            </Button>
          </Form.Item>
        </Form>

        <Text type="secondary" style={{ fontSize: 12, display: 'block', textAlign: 'center', marginTop: 16 }}>
          如忘记密码，请联系系统管理员
        </Text>
      </Card>
    </div>
  );
};

export default LoginPage;
